/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import axios from 'axios';
import { styled } from '@mui/material/styles';
import {
  IconButton,
  IconButtonProps,
  Collapse,
  Card,
  Typography,
  CardActions,
  CardActionArea,
  CardContent,
  TextField,
  Grid,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link as RouterLink } from 'react-router-dom';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { EditToggleButton } from '../territorycard/Buttons';
import { Layer, VisitStats } from '../../types';
import config from '../../config';

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand: _, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

// eslint-disable-next-line @typescript-eslint/no-unused-vars

interface ExpandableCardProps {
  layer: Layer;
  expand: boolean;
  onExpandClick: (id: number) => () => void;
}

export function ExpandableCard(props: ExpandableCardProps) {
  const { layer, expand, onExpandClick } = props;

  const [isLock, setIsLock] = React.useState(true);
  const [parentName, setParentName] = React.useState(layer.parentName);
  const [name, setName] = React.useState(layer.name);
  const [description, setDescription] = React.useState(layer.description);
  const [stats, setStats] = React.useState<VisitStats>({} as VisitStats);
  const [coverage, setCoverage] = React.useState(0);

  const toggleIsLock = () => {
    setIsLock(!isLock);
  };

  const handleTextChanged =
    (type: string) => async (e: React.ChangeEvent<HTMLInputElement>) => {
      const text = e.target.value;
      let data = {};
      switch (type) {
        case 'parentNamt':
          setParentName(text);
          data = { parentName: text };
          break;
        case 'name':
          setName(text);
          data = { name: text };
          break;
        case 'description':
          setDescription(text);
          data = { description: text };
          break;
        default:
          break;
      }
      await axios.put(`${config.api.url}/mdsouth/layers/${layer.id}`, data);
    };

  const CardActionAreaProp = isLock
    ? {
        component: RouterLink,
        to:
          layer.parentName === ''
            ? `/map/${layer.name}`
            : `/map/${layer.parentName}/${layer.name}`,
      }
    : {};

  const getStats = async () => {
    const layer1 = layer.parentName !== '' ? layer.parentName : layer.name;
    const layer2 = layer.parentName !== '' ? `/${layer.name}` : '';
    const { data } = await axios.get(
      `${config.api.url}/mdsouth/stats/${layer1}${layer2}`,
    );
    setStats(data);
    setCoverage(((data.mets + data.visits) / data.total) * 100);
  };

  React.useEffect(() => {
    getStats();
  }, []);

  return (
    <Card>
      <CardActions disableSpacing>
        <CardActionArea {...CardActionAreaProp}>
          <CardContent sx={{ p: 1 }}>
            <Typography
              // component="h3"
              variant="subtitle1"
              color="primary"
              gutterBottom
            >
              [{parentName + name}] {description}
            </Typography>
            <Typography
              variant="subtitle2"
              color={stats.total !== 0 ? undefined : 'secondary'}
            >
              {stats.total !== 0
                ? `[${stats.visits}/${stats.mets}/${
                    stats.total
                  }] (${coverage.toFixed(2)}%)`
                : '구역조사 필요'}
            </Typography>
          </CardContent>
        </CardActionArea>
        <EditToggleButton visible isLock={isLock} onClick={toggleIsLock} />
        <ExpandMore
          expand={expand}
          onClick={onExpandClick(layer.id)}
          aria-expanded={expand}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </ExpandMore>
      </CardActions>
      <Collapse in={expand} timeout="auto" unmountOnExit>
        <CardContent sx={{ ml: 2, mr: 2, p: 1 }}>
          {!isLock ? (
            <Grid
              container
              spacing={1}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <TextField
                size="small"
                variant="standard"
                label="parentName"
                placeholder="parent layer name"
                onChange={handleTextChanged('parentName')}
                value={parentName}
              />
              <TextField
                size="small"
                variant="standard"
                label="Name"
                placeholder="layer name"
                onChange={handleTextChanged('name')}
                // id="subtitle-edit"
                value={name}
              />
              <TextField
                size="small"
                variant="standard"
                label="Description"
                placeholder="layer description"
                onChange={handleTextChanged('description')}
                // id="subtitle-edit"
                value={description}
              />
            </Grid>
          ) : (
            <ResponsiveContainer width="100%" height="100%" minHeight={100}>
              <BarChart
                width={500}
                height={100}
                data={[
                  {
                    name: 'visitStats',
                    visits: stats.visits,
                    mets: stats.mets,
                    intacts: stats.total - (stats.visits + stats.mets),
                  },
                ]}
                layout="vertical"
                barSize={20}
              >
                <XAxis type="number" domain={[0, stats.total]} />
                <YAxis dataKey="name" type="category" hide />
                <Tooltip />
                <Legend iconSize={8} />
                <Bar
                  label
                  name="만남"
                  dataKey="mets"
                  stackId="a"
                  fill="#1b5e20"
                />
                <Bar
                  label
                  name="재방필요"
                  dataKey="visits"
                  stackId="a"
                  fill="#4caf50"
                />
                <Bar
                  label
                  name="미방문"
                  dataKey="intacts"
                  stackId="a"
                  fill="#a5d6a7"
                />
              </BarChart>
            </ResponsiveContainer>
          )}
        </CardContent>
      </Collapse>
    </Card>
  );
}
